<div fxLayout="row">

  <mat-card class="content-card container-md" fxFlex="50">
    <mat-card-content *ngIf="inquiry">

      <div style="padding-top: 10px">
        <div fxLayout="row" style="width: 100%">
          <div fxFlex="50">
            <h3>Risk check</h3>
          </div>
          <div fxFlex="50" class="text-right">
            <h3>Current: <span class="{{ getRiskClass() }}">{{ getCurrentRiskLevel() }}</span></h3>
          </div>
        </div>
      </div>






      <h4>Customer</h4>
      <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCustomer ">
        <app-content-row [field]="field" [entity]="inquiry.customer"></app-content-row>
      </div>

      <h4>Loads</h4>
      <div class="list-item" fxLayout="row" *ngFor="let field of fieldsLoad ">
        <app-content-row [field]="field" [entity]="inquiry.customer"></app-content-row>
      </div>

    </mat-card-content>
    <mat-card-actions align="end">
        <a mat-raised-button color="primary" (click)="returnBack()">Back</a>
    </mat-card-actions>
  </mat-card>

  <mat-card class="content-card container-md" fxFlex="50">
    <mat-card-header>
      <mat-card-title>
        <h5>Risk Assessment</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="inquiry">

      <strong>{{ inquiry.inquiryUser.firstName }} {{ inquiry.inquiryUser.lastName }}:</strong><br />
      {{ inquiry.inquiryComment }}
      <br /><br />

      <form *ngIf="inquiryForm && inquiry" [formGroup]="inquiryForm" (ngSubmit)="onSubmit()">
        <mat-form-field style="width: 90%">
          <input matInput placeholder="Comment" formControlName="finishedComment">
        </mat-form-field>
        <br /><br />
        <mat-form-field>
          <mat-select placeholder="Risk Level" formControlName="finishedRiskLevel">
            <mat-option [value]="0">Low</mat-option>
            <mat-option [value]="1">Medium</mat-option>
            <mat-option [value]="2">High</mat-option>
          </mat-select>
        </mat-form-field>
      </form>

    </mat-card-content>
    <mat-card-actions align="start">
      <button *ngIf="inquiryForm != null && ( currentUserIsSuperAdmin() || currentUserIsCompliance() || currentUserIsFinanceManager() )" mat-raised-button color="primary" type="submit" [disabled]="!inquiryForm.valid || inquiryForm.pristine" (click)="onSubmit()">save</button>
      <button *ngIf="inquiryForm != null && ( currentUserIsSuperAdmin() || currentUserIsCompliance() || currentUserIsFinanceManager() )" mat-raised-button color="warn" type="submit" (click)="delete()">leave Unchanged</button>
    </mat-card-actions>
  </mat-card>



</div>
